import Paper from "@material-ui/core/Paper"
import { styled } from "@material-ui/core/styles"

export default styled(Paper)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(4),
  borderRadius: theme.spacing(2),
}))
